import { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useModal } from '../../context/Modal/useModal';
import Button, { ButtonType } from '../Button/Button';
import { MODAL_TITLE_ID } from './ModalLayout';
import './Modal.css';

function Modal() {
  const { content, onClose, isOpen } = useModal();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const intl = useIntl();

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog || typeof dialog.showModal !== 'function') {
      return;
    }
    if (isOpen && !dialog.open) {
      dialog.showModal();
    } else if (!isOpen && dialog.open) {
      dialog.close();
    }
  }, [isOpen]);

  return (
    <dialog
      ref={dialogRef}
      className={`modal ${isOpen ? 'open' : 'closed'}`}
      aria-labelledby={MODAL_TITLE_ID}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={onClose}
    >
      <div className="modal-wrapper" onClick={(e) => e.stopPropagation()}>
        <div className="close-button-wrapper">
          <Button
            onClick={onClose}
            type={ButtonType.PrimaryLink}
            ariaLabel={intl.formatMessage({ id: 'modal.close' })}
          >
            &times;
          </Button>
        </div>
        <div className="modal-content">{content}</div>
      </div>
    </dialog>
  );
}

export default Modal;
